module.exports = __webpack_public_path__ + "static/media/animated-sound-bars.95b7fea7.gif";